import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { ChangePurchaseTenderProcessingStatusMutationResponse, ChangePurchaseTenderProcessingStatusQueryParams, ChangePurchaseTenderProcessingStatus400, ChangePurchaseTenderProcessingStatus401, ChangePurchaseTenderProcessingStatus403, ChangePurchaseTenderProcessingStatus422, ChangePurchaseTenderProcessingStatus429, ChangePurchaseTenderProcessingStatus500 } from "../types/ChangePurchaseTenderProcessingStatus";

/**
 * @link /api/purchase-tenders/v1/tender/do_update-for-processing-status
 */

export function useChangePurchaseTenderProcessingStatus <TData = ChangePurchaseTenderProcessingStatusMutationResponse, TError = ChangePurchaseTenderProcessingStatus400 | ChangePurchaseTenderProcessingStatus401 | ChangePurchaseTenderProcessingStatus403 | ChangePurchaseTenderProcessingStatus422 | ChangePurchaseTenderProcessingStatus429 | ChangePurchaseTenderProcessingStatus500>(params: ChangePurchaseTenderProcessingStatusQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "patch",
        url: `/api/purchase-tenders/v1/tender/do_update-for-processing-status`,
        
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
